// extracted by mini-css-extract-plugin
module.exports = {"primaryText":"TaxBudgetsModal-module__primaryText--1sHOV","secondaryText":"TaxBudgetsModal-module__secondaryText--3cykE"};